import { fetchSameOrigin } from '../Utils';
function deleteCaregiver(memberId, roleId) {
  return fetchSameOrigin(
    `/members/${memberId}/caregivers/${roleId}`, 
    'DELETE',
    { body: JSON.stringify({
    member_id: memberId,
    id: roleId,
    })}
  )
  .then(r => r.json())
  .then(({ message })=> new Promise((resolve) => {
    if(message){
      console.log('no errors');
      resolve({
        message: message
      });
    }
  })
  .finally(() =>{
    window.location.reload()
  }));
}

export default deleteCaregiver;
